module.exports = __webpack_public_path__ + "img/option-education-funds-filled.5587488.png";